<div class="content-wrapper">
  @for (item of resourceItems; track item) {
    <black-accordion-resource
      (deleteEvent)="onDelete($event)"
      [item]="item"
      [referenceId]="modelId"
    ></black-accordion-resource>
  }
  <ng-content></ng-content>
</div>
